import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-md p-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center py-6"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative mb-6"
}
const _hoisted_4 = { class: "block sm:inline" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_9 = { class: "space-y-3" }
const _hoisted_10 = { class: "col-span-1" }
const _hoisted_11 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_14 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_15 = { class: "border border-gray-200 rounded-md p-4 bg-gray-50" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "mt-2 whitespace-pre-wrap" }
const _hoisted_18 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_19 = { class: "border border-gray-200 rounded-md p-4 bg-white" }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "mt-2 whitespace-pre-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Email Template Processing Test", -1)),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary" }, null, -1),
          _createElementVNode("span", { class: "ml-2" }, "Loading template...", -1)
        ])))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("strong", { class: "font-bold" }, "Error:", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.error), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Select Template", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplateId) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadTemplate && _ctx.loadTemplate(...args))),
                class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("option", { value: "" }, "-- Select a template --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableTemplates, (template) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: template.id,
                    value: template.id
                  }, _toDisplayString(template.template_name), 9, _hoisted_7))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.selectedTemplateId]
              ])
            ]),
            (_ctx.originalTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Variable Values", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-3" }, " Enter values for the variables in this template. These will be used to replace the placeholders. ", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variableValues, (value, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "grid grid-cols-3 gap-4"
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("label", _hoisted_11, _toDisplayString(key), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.variableValues[key]) = $event),
                            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.processTemplate && _ctx.processTemplate(...args))),
                            class: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary",
                            placeholder: `Value for ${key}`
                          }, null, 40, _hoisted_13), [
                            [_vModelText, _ctx.variableValues[key]]
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.originalTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Original Template", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "font-medium" }, "Subject:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.originalTemplate.subject), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-medium" }, "Body:", -1)),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.originalTemplate.content), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.processedTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "Processed Template", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-medium" }, "Subject:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.processedTemplate.subject), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "font-medium" }, "Body:", -1)),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.processedTemplate.content), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
  ]))
}